import { performDelete } from 'core/apiUtils';

export function deleteAccount() {
  return performDelete('/account');
}
